import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URI}/api/roles`
});

export const getRoles = async () => {
  const response = await API.get("/");
  return response.data;
};

export const getAvailablePages = async () => {
  const response = await API.get("/pages");
  return response.data.pages;
};

export const createRole = async (data) => {
  const response = await API.post("/", data);
  return response.data;
};

export const updateRole = async (roleId, data) => {
  const response = await API.put(`/${roleId}`, data);
  return response.data;
};

export const deleteRole = async (roleId) => {
  const response = await API.delete(`/${roleId}`);
  return response.data;
};

export default API;
